<template>
  <div>
    <portal-target  name="testimonials-dialog" />
    <AboutVoRita></AboutVoRita>
    <AboutHeadquartersFounders></AboutHeadquartersFounders>
    <Header />
    <div class="">
      <slot></slot>
    </div>
    <Footer />
  </div>
</template>